import PropTypes from 'prop-types'
import BasicObject from 'model/basicObject'
import { isNil } from 'ramda'

class Slot extends BasicObject {
  constructor(init) {
    super(init)
    // console.log('> Slot constructor -', init)
    if (isNil(init)) return undefined
    this._kind = init.kind
    this._description = init.description
    this._display_kind = init.display_kind
    // this.delete = false
  }

  static shape = {
    id: PropTypes.string.isRequired,
    kind: PropTypes.string,
    description: PropTypes.string
  }

  remove(v) {
    this._delete = v
    return this
  }

  get kind() {
    return this._kind
  }

  get description() {
    return this._description
  }

  get display_kind() {
    return this._display_kind
  }

  get delete() {
    return this._delete
  }

  get toObject() {
    return {
      id: this.id,
      kind: this.kind,
      ...(this.delete && { delete: true })
    }
  }

  get isSlot() {
    return true
  }
}

export default Slot
